import { Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import EmployeeSelectionAndMutation from "./Employee/EmployeeSelectionAndMutation";

import { Container } from "./styles";
import EmployeePersonalAndChangingDocuments from "../../containers/EmployeeData/EmployeePersonalAndChangingDocuments";
import LoadingOverlay from "../../containers/LoadingOverlay/LoadingOverlay";

import { useAppSelector } from "../../custom-hooks/redux/redux";
import useAbortableLoadResponse from "../../custom-hooks/useAbortableLoadResponse/useAbortableLoadResponse";
import { isTabAuthorized } from "../../custom-hooks/useAuthorization/useAuthorization";
import { EmployeeDTO } from "../../models/employees";
import { NotAuthorizedPage } from "../../reusable-components/NotAuthorizedPage/NotAuthorizedPage";
import { EmployeesApiService } from "../../services/employees/employees-api.service";

import { MyDataLinks } from "../../widgetLink";
const MyDocuments = () => {
  const [employee, setEmployee] = useState<EmployeeDTO | null>(null);

  const { currentUserAuthorizations, currentUserData } = useAppSelector((state) => state.currentUserReducer);

  const allowDataAndDocuments =
    isTabAuthorized(MyDataLinks.Data, currentUserAuthorizations, currentUserData) || currentUserAuthorizations?.isEE;

  const { response, loading, error } = useAbortableLoadResponse<EmployeeDTO>(
    EmployeesApiService,
    {},
    "/GetCurrentUserEmployees"
  );

  useEffect(() => {
    if (response?.items) setEmployee(response?.items[0] ?? null);
  }, [response?.items]);

  return (
    <>
      {allowDataAndDocuments ? (
        <LoadingOverlay
          loading={loading}
          error={error}
        >
          <Container>
            <EmployeeSelectionAndMutation
              employee={employee}
              handleChangeEmployee={setEmployee}
              documentsOrData={"documents"}
            />
            {employee ? (
              <EmployeePersonalAndChangingDocuments
                employee={employee}
                forManager={false}
              />
            ) : (
              <Typography>Please select an employee</Typography>
            )}
          </Container>
        </LoadingOverlay>
      ) : (
        <NotAuthorizedPage />
      )}
    </>
  );
};

export default MyDocuments;
